// extracted by mini-css-extract-plugin
module.exports = {"report":"report_report__Mgtcr","title":"report_title__3cgNh","review":"report_review__1RYWp"};